import React, { useState, useEffect } from 'react';
import {
  Grid,
  Button,
  TextField,
  MenuItem,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CommandModal from './CommandModal';
import CircularLoading from 'components/loading/CircularLoading';
import { post, fetchAuthenticated } from 'services/fetch';
import moment from 'moment';

const COMMANDS = [
  { label: 'Enviar comando de abertura', value: '1', successMsg: 'Comando enviado com sucesso.' },
  { label: 'Cancelar envio de comando', value: '0', successMsg: 'Solicitação de cancelamento enviada com sucesso.' },
];

const useStyles = makeStyles(theme => ({
  lockInfo: {
    backgroundColor: theme.palette.grey[100],
    borderRadius: 4,
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  lockInfoLabel: {
    fontSize: 12,
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
  },
  lockInfoValue: {
    fontSize: 12,
    color: theme.palette.text.primary,
  },
  lastCommandInfo: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
    marginBottom: theme.spacing(2),
  },
  successMessage: {
    color: theme.palette.success ? theme.palette.success.main : '#4caf50',
    fontSize: 13,
    marginTop: theme.spacing(1),
  },
  errorMessage: {
    color: theme.palette.error.main,
    fontSize: 13,
    marginTop: theme.spacing(1),
  },
}));

const CommandLockModal = ({ isOpen, setCurrentAction, lock, ...rest }) => {
  const classes = useStyles();

  const resolvedLock = lock || rest.lock || (rest.lastEvent && rest.lastEvent.lockSource) || null;
  const lockId = resolvedLock && (resolvedLock._id || resolvedLock.lockId);
  const unitnumber = (resolvedLock && resolvedLock.unitnumber) || '';
  const lockName = (resolvedLock && resolvedLock.name) || '';

  const equipmentId = rest._id || rest.equipmentId || null;
  const imei = rest.imei || null;

  const [open, setOpen] = useState(isOpen !== false);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(COMMANDS[0]);
  const [feedback, setFeedback] = useState(null);
  const [lastOpenCommandDate, setLastOpenCommandDate] = useState(null);

  useEffect(() => {
    if (!lockId) return;
    fetchAuthenticated('get', `lock/command-history?lockId=${lockId}&limit=1&value=1&success=true`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0 && data[0].createdAt) {
          setLastOpenCommandDate(data[0].createdAt);
        }
      })
      .catch(() => {});
  }, [lockId]);

  const handleClose = () => {
    setOpen(false);
    setCurrentAction && setCurrentAction(null);
  };

  const handleChange = (e) => {
    const cmd = COMMANDS.find(c => c.label === e.target.value);
    if (cmd) setSelected(cmd);
    setFeedback(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!lockId) {
      setFeedback({ type: 'error', message: 'Cadeado não identificado.' });
      return;
    }

    setLoading(true);
    setFeedback(null);

    try {
      const response = await post('lock/command', {
        lockId,
        equipmentId,
        imei,
        param: 'output',
        value: selected.value,
      });

      const result = await response.json();

      if (response.ok && result && result.success) {
        setFeedback({ type: 'success', message: selected.successMsg });
        if (selected.value === '1') {
          setLastOpenCommandDate(new Date().toISOString());
        }
      } else {
        const errMsg = (result && result.error) || (result && result.message) || 'Falha ao enviar o comando.';
        setFeedback({ type: 'error', message: errMsg });
      }
    } catch (err) {
      setFeedback({ type: 'error', message: 'Erro ao enviar o comando.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <CommandModal title="Comandos Cadeado" isOpen={open} onClose={handleClose}>
      <form onSubmit={handleSubmit}>
        {(unitnumber || lockName) && (
          <Grid container className={classes.lockInfo}>
            {lockName && (
              <Grid item xs={12}>
                <Typography display="inline" className={classes.lockInfoLabel}>Cadeado: </Typography>
                <Typography display="inline" className={classes.lockInfoValue}>{lockName}</Typography>
              </Grid>
            )}
            {unitnumber && (
              <Grid item xs={12}>
                <Typography display="inline" className={classes.lockInfoLabel}>Unitnumber: </Typography>
                <Typography display="inline" className={classes.lockInfoValue}>{unitnumber}</Typography>
              </Grid>
            )}
          </Grid>
        )}

        {lastOpenCommandDate && (
          <Typography className={classes.lastCommandInfo}>
            Último comando de abertura enviado às {moment(lastOpenCommandDate).format('DD/MM/YYYY HH:mm')}
          </Typography>
        )}

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Comando"
              value={selected.label}
              onChange={handleChange}
            >
              {COMMANDS.map(cmd => (
                <MenuItem key={cmd.label} value={cmd.label}>{cmd.label}</MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>

        {feedback && (
          <Typography className={feedback.type === 'success' ? classes.successMessage : classes.errorMessage}>
            {feedback.message}
          </Typography>
        )}

        <Grid container justify="flex-end" style={{ marginTop: 16 }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            style={{ padding: '10px 32px' }}
          >
            Enviar comando
          </Button>
        </Grid>
      </form>
      <CircularLoading isLoading={loading} />
    </CommandModal>
  );
};

export default CommandLockModal;
